import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { DashboardDataProvider } from "./context/DashboardDataContext";
import { UiPreferencesProvider } from "./context/UiPreferencesContext";
import { DashboardLayout } from "./layout/DashboardLayout";
import { ExecutiveOverview } from "./pages/ExecutiveOverview";
import { PatternIntelligence } from "./pages/PatternIntelligence";
import { AssessmentFunnel } from "./pages/AssessmentFunnel";
import { ConversionRevenue } from "./pages/ConversionRevenue";
import { CohortsTrends } from "./pages/CohortsTrends";
import { SubmissionsExplorer } from "./pages/SubmissionsExplorer";
import { FounderProfile } from "./pages/FounderProfile";
import { Settings } from "./pages/Settings";
import "./App.css";

export default function App() {
  return (
    <UiPreferencesProvider>
      <DashboardDataProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<DashboardLayout />}>
              <Route index element={<ExecutiveOverview />} />
              <Route path="patterns" element={<PatternIntelligence />} />
              <Route path="funnel" element={<AssessmentFunnel />} />
              <Route path="conversion" element={<ConversionRevenue />} />
              <Route path="cohorts" element={<CohortsTrends />} />
              <Route path="submissions" element={<SubmissionsExplorer />} />
              <Route path="founder" element={<FounderProfile />} />
              <Route path="settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </DashboardDataProvider>
    </UiPreferencesProvider>
  );
}
